import produce from 'immer'

import ActionTypes from './ActionTypes'

const REACT_APP_REGION = process.env.REACT_APP_REGION || 'hk'

/** @type {IAppState} */
export const initialState = {
  isInit: false,
  lang: REACT_APP_REGION === 'th' ? 'th-TH' : 'zh-HK', // 預設語言
  adPop: {
    lastPopDate: '',
    visible: false,
  },
  ipInfo: {},
}

export default produce((draft, action) => {
  switch (action?.type) {
    case ActionTypes.INIT: {
      draft.isInit = true
      break
    }

    case 'LOGOUT': {
      return initialState
    }

    case ActionTypes.UPDATE_LANG: {
      const { lang } = action.payload
      draft.lang = lang
      break
    }

    case ActionTypes.UPDATE_ADLASTPOPDATE: {
      draft.adPop.lastPopDate = action.payload
      break
    }

    case ActionTypes.POP_AD: {
      draft.adPop.visible = true
      break
    }

    case ActionTypes.CLOSE_AD: {
      draft.adPop.visible = false
      break
    }

    case ActionTypes.UPDATE_IP_INFO: {
      draft.ipInfo = action.payload.ipInfo
      break
    }

    default:
      break
  }
}, initialState)
